import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DateRange } from 'react-date-range';
import moment from 'moment';
import { TextField, Toggle } from 'material-ui';
import { StyleSheet, css } from 'aphrodite';

import * as RateQuoteActions from '../../store/actions/RateQuoteActions';

@connect(state => ({
  arrival: state.RateQuote.get('arrival'),
  departure: state.RateQuote.get('departure'),
  dateString: state.RateQuote.get('dateString'),
  showDatePicker: state.RateQuote.get('showDatePicker'),
}))
export default class DateEntry extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    arrival: PropTypes.number,
    departure: PropTypes.number,
    dateString: PropTypes.string,
    showDatePicker: PropTypes.bool,
  };

  static defaultProps = {
    showDatePicker: false,
    arrival: null,
    departure: null,
    dateString: '',
  };

  handleSelect = range => {
    this.props.dispatch(RateQuoteActions.updateDateRange(range));
  };

  updateDate = e => {
    const value = e.target.value.toUpperCase();
    this.props.dispatch(RateQuoteActions.updateDateString(value));
  };

  toggleDatePicker = e => {
    this.props.dispatch(RateQuoteActions.toggleDatePicker(e.target.checked));
  };

  render() {
    const { arrival, departure } = this.props;

    return (
      <div>
        <div className={css(styles.container)}>
          <TextField
            value={this.props.dateString}
            floatingLabelText='Travel Dates'
            onChange={this.updateDate}
          />
          <Toggle
            checked={this.props.showDatePicker}
            onClick={this.toggleDatePicker}
            label='(show date picker)'
            labelPosition='right'
            className={css(styles.toggle)}
          />
        </div>
        {this.props.showDatePicker ? (
          <DateRange
            onChange={this.handleSelect}
            startDate={arrival ? moment(arrival) : ''}
            endDate={departure ? moment(departure) : ''}
          />
        ) : (
          ''
        )}
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'baseline',
  },
  toggle: {
    width: 200,
    marginLeft: 'auto',
  },
});



// WEBPACK FOOTER //
// /src/components/RateQuoteGenerator/DateEntry.js